import React, { useContext } from 'react';
import { Navbar, NavbarBrand } from 'reactstrap';
import { Link } from 'react-router-dom';
import { withRouter } from "react-router";
import { FormSelector } from '../FormSelector';
import { SettingsContext } from '../SettingsContext';
import './NavMenu.css';

const NavMenu = (props) => {
	const settings = useContext(SettingsContext);

	return (
		<header>
			<Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
				<div className={settings.containerClass}>
					<NavbarBrand tag={Link} to="/">{settings.siteName}</NavbarBrand>
					{
						settings.features.enableNavigation ?
							<FormSelector {...props} />
						: null
					}
				</div>
			</Navbar>
		</header>
	);
}

export default withRouter(NavMenu);
